<template>
  <b-container class="mt-4" fluid>
    <p>
      <strong>Sobre o sistema</strong>
    </p>
    <p class="text-justify">
      O FICAR &copy; (Ferramenta Informatizada de Cadastro de Acesso ao Refeitório) foi desenvolvido
      pelo SETISD para o Complexo Hospitalar da UFC.
    </p>
    <p>Versão: {{ version }}</p>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION
    };
  }
};
</script>

<style>
</style>